import React from "react";
import axios from "axios";
import "./CheckBandwidth.css";

const USER_LIMITS_URL =
  "https://utt6psyc8c.execute-api.us-west-2.amazonaws.com"

export default (WrappedComponent) => {
  return class CheckBandwidth extends React.PureComponent {
    
    constructor(props) {
      super(props)
      this.state = {
        loading: true,
        bandwidthExceeded: false,
        loadingLong: 0,
        company: ''
      }
    }

    componentDidMount() {
      this.checkBandwidthCap();
    }

    getCompany = async () => {
      try {
        let temp = window.location.href;
        temp = temp.split('/vod/');
        let location = temp[temp?.length - 1].split('/')[0];
        this.setState({ ...this.state, company: location });
        return true;
      } catch (err) {
        console.error(err);
        return false;
      };
    };

    checkBandwidthCap = async () => {
      if(this.props.user) {
        try {
          let res = await axios.post(`${USER_LIMITS_URL}/${this.props.user}/use/bandwidth`, {amount: 1});
          this.setState({bandwidthExceeded: false, loading: false, loadingLong: 0})
          return
        } catch (err) {
          if(err.response) {
            if(err.response.status === 403) {
              this.getCompany();
              if (
                this.state?.company &&
                (
                  this.state?.company !== 'akaku' 
                  || this.state?.company !== 'demo'
                  || this.state?.company !== 'castus-training'
                  || this.state?.company !== 'castus'
                )
              ) {
                this.setState({bandwidthExceeded: true, loading: false, loadingLong: 0});
              } else {
                this.setState({bandwidthExceeded: false, loading: false, loadingLong: 0})
              };
              return
            } else {
              this.setState({loadingLong: this.state.loadingLong + 1})
              setTimeout(this.checkBandwidthCap, 1000)
              return
            }
          }
        }
      }
      setTimeout(this.checkBandwidthCap, 1000)
    }

    render() {
      let {loading, bandwidthExceeded, loadingLong} = this.state
      if(loading) {
        let loadingMsg = ""
        if(loadingLong) {
          loadingMsg = <span className="loadingMsg">Retrying: {loadingLong}</span>
        }
        return (
          <div className="checkBandwidthLoader">
            <div className="m-5">
              <span className="spinner-border" role="status"/>
              {loadingMsg}
            </div>
          </div>
        )
      } 
      else if (bandwidthExceeded) {
        return (
          <div className="bandwidthExceededMessage">
            <h1>
              This video is temporarily unavailable for viewing
            </h1>
          </div>
        )
      } 
      else {
        return (<WrappedComponent {...this.props} checkBandwidthCap={this.checkBandwidthCap}/>)
      }
    }

  }
}
